import { FETCH_USERS_PAGINATED } from '@/store/actionTypes'

export const ADD_SPACE = 'organization/spaces/CREATE'
export const ADD_SPACE_SUCCESS = `${ADD_SPACE}_SUCCESS`
export const ADD_SPACE_ERROR = `${ADD_SPACE}_ERROR`

export const UPDATE_SPACE = 'organization/spaces/UPDATE'
export const UPDATE_SPACE_SUCCESS = `${UPDATE_SPACE}_SUCCESS`

export const ADD_SPACE_ADMIN = 'organization/spaces/admins/ADD'
export const ADD_SPACE_ADMIN_SUCCESS = `${ADD_SPACE_ADMIN}_SUCCESS`

export const REMOVE_SPACE_ADMIN = 'organization/spaces/admins/REMOVE'
export const REMOVE_SPACE_ADMIN_SUCCESS = `${REMOVE_SPACE_ADMIN}_SUCCESS`

export const FETCH_SPACE_MEMBERS = 'organization/spaces/members/GET'
export const FETCH_SPACE_MEMBERS_SUCCESS = `${FETCH_SPACE_MEMBERS}_SUCCESS`

export const FETCH_ORG_ADMINS_TO_ADD = `${FETCH_USERS_PAGINATED}_ORG_ADMINS_TO_ADD`
export const FETCH_ORG_ADMINS_TO_ADD_SUCCESS = `${FETCH_ORG_ADMINS_TO_ADD}_SUCCESS`
